"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseWithSchema = parseWithSchema;
function parseWithSchema({ data, schema }) {
    const result = schema.safeParse(data);
    if (!result.success) {
        throw new Error(`Data validation failed: ${result.error.message}`);
    }
    return result.data;
}
